import React from 'react'
import PropTypes from 'prop-types';

import { Selector } from '@leverege/ui-elements'
import { Units } from '@leverege/api-attributes';
import { LabelGroup, Section } from '~/views';
import BaseAttributeEditor from './BaseAttributeEditor';
import NumberAttributeEditor from './NumberAttributeEditor';

import style from './style.css'

export default class UnitAttributeEditor extends React.Component {

  static propTypes = {
    attribute : PropTypes.object,
    blueprint : PropTypes.object,
    onChange : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props )
    this.changePath = BaseAttributeEditor.ChangePath.bind( this )

  }

  render() {
    const attr = this.props.attribute;
    const blueprint = this.props.blueprint;
    if ( attr == null ) {
      return <div />
    }
    const unitsOfType = Units.getUnitsOfType( attr.type );
    const selector = null;
    const options = [];
    const unitValues = [];
    if ( unitsOfType ) {
      for ( let n = 0; n < unitsOfType.length; n++ ) {
        const unit = unitsOfType[n];
        unitValues.push( { value : unit.symbol, name : unit.name } );
        options.push( <option key={unit.symbol} value={unit.symbol}>{unit.name}</option> );
      }
    }
    return (
      <div>
        <NumberAttributeEditor {...this.props} numberHeader="">
          <Section header="Units">
            <LabelGroup className={style.unitOptionsGroup}>
              <label>Unit</label>
              <Selector
                values={unitValues}
                value={attr.base}
                onChange={( value ) => { this.changePath( 'base', value.value, false ); }} />
            </LabelGroup>
          </Section>
        </NumberAttributeEditor>    
      </div>
    ) 
  }
}
